/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import {Version} from '@angular/core';

/**
 * @publicApi
 */
export const VERSION = /* @__PURE__ */ new Version('21.2.19');
